/**
 * DateInput class adds functionality to clear date input's current value.
 */
class DateInput {

  constructor( element ) {
    this._element = element;

    this._clearButton = this._element.querySelector('.clear');
    this._dateInput = this._element.querySelector('input[type="date"]');

    if( this._clearButton ) {
      this._clearButton.addEventListener('click', this._onClearClicked.bind(this));
    }
  }

  _onClearClicked() {
    if( this._dateInput.value !== '') {
      this._dateInput.value = '';
      this._dateInput.dispatchEvent( new CustomEvent('change', { detail: '' }) );
    }
  }

  static init() {
    document.querySelectorAll('.v10-date-input').forEach(dateInputElement => {
      new DateInput(dateInputElement);
    });
  }
}

export default DateInput;
